import $ from 'jquery';

export default () => {

    var scroll = $(window).scrollTop();
    if (scroll > 10) {
        $('body').addClass('collapsed');
    } else {
        $('body').removeClass('collapsed');
    }

    $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll > 10) {
            $('body').addClass('collapsed');
        } else {
            $('body').removeClass('collapsed');
        }
    });
}


// WEBPACK FOOTER //
// ../views/partials/header/header.js